export default {
    
    filters: {

        /**
         * Parse number/string to comma thousand seperated format
         * 
         * @param { string } value 
         */
        thousandSeparator(value) {
            let newVal = (value / 1).toFixed(2).replace(/,/g, "")
            if (newVal < 0) newVal = '(' + newVal + ')'
            return newVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").replace(/-/g, "");
        }

    },

    methods: {

        /**
         * Parse string to number format
         * 
         * @param { string } string 
         */
        parseNumber(string) {
            return string.replace(/,/g, "").trim()
        },

        /**
         * Parse number to price format
         * 
         * @param { number } number 
         */
        parsePrice(number) {
            let newVal = (number / 1).toFixed(2).replace(/,/g, "");
            return newVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        
    }
}
